module.exports = __webpack_public_path__ + "static/media/renbtc.b3d95dcb7273d762369254d49a8a33fc.png";